import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';

import { AppComponent } from './app.component';
import { PercentagePipe } from './pipes/percentage.pipe';
import { CommaPipe } from './pipes/comma.pipe';
import { EmptyStateModule } from '@pxblue/angular-components';
import { MatIconModule } from '@angular/material/icon';
import { ResponsiveDirective } from './directives/responsive.directive';
import { HighchartsChartModule } from 'highcharts-angular';

@NgModule({
    declarations: [AppComponent, CommaPipe, PercentagePipe, ResponsiveDirective],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        EmptyStateModule,
        FlexLayoutModule,
        FormsModule,
        HighchartsChartModule,
        HttpClientModule,
        MatCardModule,
        MatIconModule,
        MatRippleModule,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
